const styles = theme => ({
  root: {
    maxWidth: '100%',
    maxHeight: '560px',
    overflow: 'auto',
    margin: '30px',
    marginTop: '0px'
  },
  cellError: {
    color: theme.palette.problemsTable.problem
  },
  cellOk: {
    color: theme.palette.problemsTable.muted
  },
  tableTitle: {
    color: '#fff',
    margin: '30px',
    marginBottom: '0px'
  },
  problemsDowloadButton: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  sortHeader: {
    cursor: 'pointer'
  }
});

export default styles;


// WEBPACK FOOTER //
// ./src/main/components/styles/ProblemsTableStyles.js